import request from '../request.js'

// 登录
const loginIn = function (data) {
    return request({
        url: 'sysUser/login',
        method: 'post',
        data
    })
}

// 获取用户信息
const getInfo = function (data) {
    return request({
        url: 'sysUser/getUserInfo',
        method: 'post',
        data
    })
}

// 退出登录
const loginOut = function (data)  {
    return request({
        url: 'sysUser/logout',
        method: 'post',
        data
    })
}

// 获取人员列表
const getUsers = function (data)  {
    return request({
        url: 'sysUser/getUsers',
        method: 'post',
        data
    })
}

// 启用、禁用人员
const updateUserState = function (data)  {
    return request({
        url: 'sysUser/updateUserState',
        method: 'post',
        data
    })
}

// 新增人员
const insertSysUser = function (data)  {
    return request({
        url: 'sysUser/insertSysUser',
        method: 'post',
        data
    })
}

// 获取人员信息
const getUserInfo = function (data)  {
    return request({
        url: 'sysUser/selectById',
        method: 'post',
        data
    })
}

// 获取用户组人员列表
const getGroupUsers = function (data)  {
    return request({
        url: 'sysUser/getGroupUsers',
        method: 'post',
        data
    })
}

const deleteById = function (data)  {
    return request({
        url: 'sysUser/deleteById',
        method: 'post',
        data
    })
}


// 修改密码--叶凡
const updatePassword = function (data) {
    return request({
        url: 'sysUser/updateOwnPass',
        method: 'post',
        data
    })
}

//重置密码（yef）
const resetPassword = function (data)  {
    return request({
        url: 'sysUser/resetPassword',
        method: 'post',
        data
    })
}

export {
    loginIn,
    getInfo,
    loginOut,
    getUsers,
    updateUserState,
    insertSysUser,
    getUserInfo,
    getGroupUsers,
    deleteById,
    resetPassword,
    updatePassword
}